import { SIZES, BREAKPOINTS } from '@/Scripts/constants';

function getSizes (sizes) { // [{cols: 2, breakPoint: 'md'}, {cols: 3, breakPoint: 'lg'}]
  const vw = Math.min(window.innerWidth, SIZES.CONTENT_MAX_WIDTH);
  const percent = (val) => { return vw / val / window.innerWidth * 100; };

  const sizesArray = sizes
    .map(param => {
      const object = {};
      if (typeof param.breakPoint === 'string') {
        object.minWidth = BREAKPOINTS[param.breakPoint.toUpperCase()];
      } else {
        object.minWidth = param.breakPoint;
      }
      const mediaQuery = object.minWidth ? `(min-width: ${object.minWidth}px) ` : '';
      object.string = `${mediaQuery}${Math.floor(percent(param.cols))}vw`;
      return object;
    })
    .sort((a, b) => { return b.minWidth - a.minWidth; })
    .map(object => object.string);

  return sizesArray.join(', ');
}

export default getSizes;
